import React from "react";

const SearchResults = props => {
  const { headers } = props;

  const head = (head, content, key) => (
    <div className="searchResult" key={`searchResult${key}`}>
      <label>{head}</label>
      <h3>{content}</h3>
    </div>
  );
  return (
    <div className="searchBox">
      {headers.map((elem, key) => head(elem.key, elem.value, key))}
    </div>
  );
};

export default SearchResults;
